import { Card, Text, Group, Stack, Skeleton } from '@mantine/core'
import { ReactNode } from 'react'

interface StatsCardProps {
  title: string
  value: number | string
  subtitle?: string
  icon?: ReactNode
  color?: string
  loading?: boolean
}

export function StatsCard({ title, value, subtitle, icon, color = 'blue', loading }: StatsCardProps) {
  if (loading) {
    return (
      <Card shadow="sm" p="lg" radius="md">
        <Stack gap="xs">
          <Skeleton height={20} width="60%" radius="xl" />
          <Skeleton height={32} width="40%" radius="xl" />
          <Skeleton height={16} width="50%" radius="xl" />
        </Stack>
      </Card>
    )
  }

  return (
    <Card shadow="sm" p="lg" radius="md">
      <Group justify="space-between">
        <Stack gap="xs">
          <Text size="sm" c="dimmed" fw={500}>
            {title}
          </Text>
          <Text size="2rem" fw={700} lh={1}>
            {value}
          </Text>
          {subtitle && (
            <Text size="xs" c="dimmed">
              {subtitle}
            </Text>
          )}
        </Stack>
        {icon && (
          <div style={{ color: `var(--mantine-color-${color}-6)` }}>
            {icon}
          </div>
        )}
      </Group>
    </Card>
  )
}